module.exports = __webpack_public_path__ + "img/CWSE.7826e9d4.png";